import { RemoteNbsIbscbsAdmin } from "../../../../data/usecases/nbs-ibscbs/remote-nbs-ibscbs-admin";
import { NbsIbscbsAdmin } from "../../../../domain/models/nbs-ibscbs";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteNbsIbscbsAdmin = (): NbsIbscbsAdmin =>
  new RemoteNbsIbscbsAdmin("/admin/nbs-ibscbs", "/nbs", makeAxiosHttpClient());
